export default __webpack_public_path__ + "static/media/Productivity.495883f7.png";